import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  Code2, Coffee, Triangle, Layers, Server, Braces,
  Database, Cloud, GitBranch, Cpu
} from "lucide-react";
import styles from "./questions.module.scss";
import { APIConstant } from "services/api-constant";
import { useTheme } from "context/ThemeContext";

const Questions = ({ token }) => {
  const { T } = useTheme();

  const TECH_META = {
    Python:     { icon: Code2,     bg: `${T.green}1F`,  color: T.green  },
    JAVA:       { icon: Coffee,    bg: `${T.amber}1F`,  color: T.amber  },
    Java:       { icon: Coffee,    bg: `${T.amber}1F`,  color: T.amber  },
    React:      { icon: Triangle,  bg: `${T.cyan}1F`,   color: T.cyan   },
    Angular:    { icon: Layers,    bg: `${T.red}1F`,    color: T.red    },
    "Node.js":  { icon: Server,    bg: `${T.green}1F`,  color: T.green  },
    JavaScript: { icon: Braces,    bg: `${T.amber}1F`,  color: T.amber  },
    Database:   { icon: Database,  bg: `${T.purple}1F`, color: T.purple },
    Cloud:      { icon: Cloud,     bg: `${T.cyan}1F`,   color: T.cyan   },
    DevOps:     { icon: GitBranch, bg: `${T.purple}1F`, color: T.purple },
    Others:     { icon: GitBranch, bg: `${T.purple}1F`, color: T.purple },
  };
  const getMeta = (name = "") => TECH_META[name] || { icon: Cpu, bg: `${T.purple}1F`, color: T.purple };

  const navigate = useNavigate();
  const [technologies, setTechnologies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await axios.get(APIConstant.getTechnologies, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setTechnologies(res.data || []);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  return (
    <div className={styles.pageRoot}>
      <div className={styles.pageHeader}>
        <div className={styles.pageHeaderLeft}>
          <h2>Question Bank</h2>
          <p>Select a technology to manage its questions</p>
        </div>
      </div>

      {loading ? (
        <div className={styles.loader}>
          <div className={styles.spinner} />
          Loading…
        </div>
      ) : (
        <div className={styles.techGrid}>
          {technologies.map((item, i) => {
            const meta = getMeta(item.name);
            const Icon = meta.icon;
            return (
              <div
                key={item.id || i}
                className={`${styles.techCard} ${styles.fadeUp}`}
                style={{ animationDelay: `${i * 0.05}s` }}
                onClick={() => navigate(`./list/${item.id}`)}
              >
                <div className={styles.techIcon} style={{ background: meta.bg, color: meta.color }}>
                  <Icon size={24} />
                </div>
                <h5>{item.name}</h5>
                <span className={styles.techCount}>{item.question_count ?? "—"} questions</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Questions;
